import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectDocumentDetailsViewTopBar } from "./TopBar"

export const projectDocumentDetailsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectDocumentDetailsViewTopBar,
}
